module.exports = __webpack_public_path__ + "static/media/seresco.529edfea.svg";